<div class="wrapper" style="display: flex;">
    <ic-left-nav></ic-left-nav>
    <div class="main-panel-right" [class.left-menu-padding]="showMenu">
        <ic-header></ic-header>

        <div class="container-fluid">
            <ic-bread-crumb></ic-bread-crumb>
            <router-outlet></router-outlet>
        </div>
        <ic-footer></ic-footer>
    </div>
</div>